import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CarouselModule } from '../carousel/carousel.module';
import { SharedComponentsModule } from '../shared/directives/shared-components.module';
import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { InstrumentationModule } from '../shared/instrumentation/instrumentation.module';
import { KeyboardFocusTooltipModule } from '../shared/keyboard-focus-tooltip/keyboard-focus-tooltip.module';
import { MruItemModule } from '../shared/mru-item/mru-item.module';
import { ResizeModule } from '../shared/resize/resize.module';
import { TitleAnnouncerModule } from '../shared/title-announcer/title-announcer.module';
import { RecommendedComponent } from './recommended.component';

@NgModule({
    imports: [
        CarouselModule,
        CommonModule,
        IconFontModule,
        KeyboardFocusTooltipModule,
        TitleAnnouncerModule,
        MruItemModule,
        InstrumentationModule,
        ResizeModule,
        ScrollingModule,
        SharedComponentsModule
    ],
    declarations: [
        RecommendedComponent
    ],
    exports: [
        RecommendedComponent
    ]
})
export class RecommendedModule {
}
